const numberOfBabiesFromCategory = (categoryId: string) => {
  const categoryMap = [undefined, '1422', '1423', '1424'];
  return categoryMap.indexOf(categoryId);
};

export default numberOfBabiesFromCategory;
